var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mb-5",attrs:{"id":"app"}},[_c('the-header'),_c('main',[_c('transition',{attrs:{"name":"view","mode":"out-in","appear":""}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }